module.exports = __webpack_public_path__ + "img/partnerzy-03_ongeo_services.cb24192b.svg";